module.exports = __webpack_public_path__ + "static/media/Quicksand-Bold.903229dc.eot";